import { Token } from '@angular/compiler';
import { utf8Encode } from '@angular/compiler/src/util';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { VesignDataService } from './service/vesign-data.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  paramsObject;
  VendorName:string="";
  constructor(private route: ActivatedRoute,private dataService: VesignDataService<any>) { }
  ngOnInit(): void {
    setTimeout(() => {
      this.dataService.DisplayVendorName$.subscribe((value)=>{
        this.VendorName=value;  
        });
    }, 1000);
   
  }
  title = 'EsignVendorApp';
 
}
